<template>
	<div>
		<section class="section jugarView">

			<div class="tile is-ancestor">
				<div class="tile is-8 ">
					<div class="tile is-7 is-parent is-vertical">
						<FichaTecnica :user="user.user" class="tile is-child" />

						<PartidosDisponibles class="tile is-child" />
					</div>

					<div class="tile is-parent is-vertical" v-if="windowWidth > 768">
						<UltimasQuinielas :title="'Mis Quinielas'" class="tile is-child" />
						<QuinielasPublicas :title="'Quinielas Públicas'" class="tile is-child" />
					</div>
				</div>
				
				<div class="tile is-4 is-parent is-vertical" v-if="windowWidth > 768">
					<Actividad class="" />
				</div>
			</div>
		</section>
		<Notificable :isModal="true" />
	</div>
</template>

<script>
	import FichaTecnica from '@/components/FichaTecnica'
	import UltimasQuinielas from '@/components/UltimasQuinielas'
	import QuinielasPublicas from '@/components/QuinielasPublicas'
	import PartidosDisponibles from '@/components/PartidosDisponibles'
	import Actividad from '@/components/Actividad'
	//import Panel from '@/components/Panel'
	import Notificable from '@/components/Notificable'
	import { mapState } from 'vuex'

	export default {
		components: {FichaTecnica, UltimasQuinielas, QuinielasPublicas, PartidosDisponibles, Actividad, Notificable },
		props: {
			windowWidth: {
				type: Number,
				required: false 
			}
		},
		name: 'Jugar',

		data() {
			return {
				
			};
		},
		created(){
			
		},
		computed: {
			...mapState("user", ["user"])
			// ...mapState('quinielas',['ultimas_quinielas'])
		},
		metaInfo(){
			return {
				title: 'Quinielas Gratis para ti y tus amigos - Quinielazo.com'
			}
		}
	};
</script>

<style lang="css" scoped>
.jugarView{
	padding: 1rem 1rem;
}
.red{
	padding: 3em;
	flex-grow: 4;
	/*background-color: red;*/
}
</style>
